import { render, staticRenderFns } from "./ConfirmEmailChange.vue?vue&type=template&id=e25a2d16&"
import script from "./ConfirmEmailChange.vue?vue&type=script&lang=js&"
export * from "./ConfirmEmailChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports